import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { MessageService } from '../message.service';
import { UserListModel } from './models/user-list-model';
import { Observable } from 'rxjs';
import { UserModel } from './models/user-model';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends BaseService {

  private wsBase: string =  "/user/";

  constructor(http: HttpClient, messageService:MessageService) {
    super(http, messageService);
  }

  loadPage(page: number, pageSize:number, queryString:string):Observable<UserListModel> {
    var url = this.wsUrl(this.wsBase) + "list?"+"page="+page+"&pageSize="+pageSize+"&q="+queryString;
    return this.dataGET(url);
  }

  loadById(id: number):Observable<UserModel> {
    var url = this.wsUrl(this.wsBase) + "details/"+id;
    return this.dataGET(url);
  }

  saveUser(model:UserModel):Observable<UserModel> 
  {
    var url = this.wsUrl(this.wsBase)+"details";
    return this.dataPOST(url, JSON.stringify(model));
  }

  changeUserStatus(user:any){
    var url = this.wsUrl(this.wsBase) + "changestatus/"+user.Id;
    return this.dataGET(url);
  }
}
